module.exports = "<a class=v-nav-link [ngClass]=\"{'selected': selected}\" (click)=itemClick()>{{label}}</a> ";